import { render, staticRenderFns } from "./EmptyState.vue?vue&type=template&id=11b53d82&"
import script from "./EmptyState.vue?vue&type=script&lang=ts&setup=true&"
export * from "./EmptyState.vue?vue&type=script&lang=ts&setup=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('11b53d82')) {
      api.createRecord('11b53d82', component.options)
    } else {
      api.reload('11b53d82', component.options)
    }
    module.hot.accept("./EmptyState.vue?vue&type=template&id=11b53d82&", function () {
      api.rerender('11b53d82', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/pages/[town-translit]/lpu/[lpu-translit]/price/_components/PriceSection/components/PriceCatalog/EmptyState.vue"
export default component.exports